import { Navigate, Outlet } from "react-router-dom";

const PrivateRoutes = ({ idUsuario }) => {
  return idUsuario > 0 ? <Outlet /> : <Navigate to='auth/login' />;
};

export default PrivateRoutes;
